var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.selectedSn?.avatar}}),_c('h1',[_vm._v(" "+_vm._s(_vm.localizedName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }